export default {
    "defaultGameSlug": "ember"
    // "defaultGameSlug": "starcross"
    // "defaultGameSlug": "school"
    // "defaultGameSlug": "book"
}
